<template>
  <v-dialog :value="value" max-width="560" persistent>
    <v-card>
      <v-card-title class="primary white--text">Ajustes em Massa de Taxas</v-card-title>
      <v-card-text>
        <v-select
          v-model="tabela"
          :items="coberturas"
          item-text="nome"
          item-value="tabela"
          :label="rotulos.cobertura"
        ></v-select>

        <v-radio-group v-model="escopo" :label="rotulos.escopo">
          <v-radio :label="rotulos.escopoTudo" value="tudo"></v-radio>
          <v-radio :label="rotulos.escopoColuna" value="coluna"></v-radio>
          <v-radio :label="rotulos.escopoLinha" value="linha"></v-radio>
        </v-radio-group>

        <v-select
          v-if="escopo === 'coluna'"
          v-model="idColuna"
          :items="opcoesColuna"
          item-text="titulo"
          item-value="id"
          :label="rotulos.campoColuna"
        ></v-select>

        <v-select
          v-if="escopo === 'linha'"
          v-model="indiceLinha"
          :items="opcoesLinha"
          item-text="texto"
          item-value="indice"
          :label="rotulos.campoLinha"
        ></v-select>

        <v-text-field
          v-model="percentual"
          type="text"
          inputmode="decimal"
          maxlength="7"
          :label="rotulos.percentual"
          placeholder="ex: 5 ou -3,5"
        ></v-text-field>

        <div class="caption error--text" v-if="mensagemLimite">{{ mensagemLimite }}</div>
        <div class="caption grey--text" v-if="mensagemPreview">{{ mensagemPreview }}</div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat @click="fechar">Cancelar</v-btn>
        <v-btn flat color="primary" :disabled="!podeAjustar" @click="preVisualizar">
          Pré-visualizar
        </v-btn>
        <v-btn color="primary" :disabled="!podeAplicar" @click="aplicar">Aplicar Ajuste</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import gestaoTaxasHelper from './gestao-taxas-helper';

export default {
  name: 'AjusteEmMassaModal',
  props: {
    value: { type: Boolean, default: false },
    categorias: { type: Array, default: () => [] },
    coberturas: { type: Array, default: () => [] },
    tabelaAtiva: { type: String, default: '' }
  },
  data() {
    return {
      tabela: '',
      escopo: 'tudo',
      idColuna: null,
      indiceLinha: 0,
      percentual: '',
      mensagemPreview: ''
    };
  },
  computed: {
    coberturaSelecionada() {
      return this.coberturas.find(c => c.tabela === this.tabela) || null;
    },
    faixas() {
      return this.coberturaSelecionada ? this.coberturaSelecionada.faixas || [] : [];
    },
    rotulos() {
      return gestaoTaxasHelper.rotulosAjusteMassa(this.coberturaSelecionada);
    },
    opcoesColuna() {
      return gestaoTaxasHelper.colunasDa(this.coberturaSelecionada, this.categorias);
    },
    opcoesLinha() {
      return this.faixas.map((faixa, indice) => ({
        indice: indice,
        texto: gestaoTaxasHelper.tituloLinha(this.coberturaSelecionada, faixa)
      }));
    },
    percentualNumerico() {
      return gestaoTaxasHelper.parsePercentual(this.percentual);
    },
    percentualValido() {
      return this.percentualNumerico !== null && this.percentualNumerico > -100;
    },
    escopoValido() {
      if (this.escopo === 'coluna') {
        return this.idColuna !== null && this.idColuna !== undefined;
      }
      if (this.escopo === 'linha') {
        return this.indiceLinha !== null && this.indiceLinha !== undefined;
      }
      return true;
    },
    podeAjustar() {
      return this.percentualValido && this.escopoValido;
    },
    quantidadeAfetada() {
      return this.celulasAfetadas().length;
    },
    quantidadeForaDoLimite() {
      if (!this.podeAjustar) return 0;
      return this.celulasAfetadas().filter(item => !this.dentroDoLimite(this.novoFator(item.celula)))
        .length;
    },
    mensagemLimite() {
      if (this.quantidadeForaDoLimite === 0) return '';
      return (
        `${this.quantidadeForaDoLimite} taxa(s) ficariam fora do limite permitido ` +
        `(${gestaoTaxasHelper.limiteDescrito(this.coberturaSelecionada)}). Ajuste o percentual.`
      );
    },
    podeAplicar() {
      return this.podeAjustar && this.quantidadeAfetada > 0 && this.quantidadeForaDoLimite === 0;
    }
  },
  watch: {
    value(aberto) {
      if (aberto) this.reiniciar();
    },
    tabela() {
      this.indiceLinha = 0;
      this.idColuna = null;
      this.mensagemPreview = '';
    },
    escopo() {
      this.mensagemPreview = '';
    },
    idColuna() {
      this.mensagemPreview = '';
    },
    indiceLinha() {
      this.mensagemPreview = '';
    },
    percentual(valor) {
      const sanitizado = gestaoTaxasHelper.sanitizarPercentual(valor);
      if (sanitizado !== valor) {
        this.percentual = sanitizado;
        return;
      }
      this.mensagemPreview = '';
    }
  },
  methods: {
    reiniciar() {
      this.tabela = gestaoTaxasHelper.tabelaInicialAjusteMassa(this.coberturas, this.tabelaAtiva);
      this.escopo = 'tudo';
      this.idColuna = null;
      this.indiceLinha = 0;
      this.percentual = '';
      this.mensagemPreview = '';
    },
    formatarPercentual(pct) {
      const sinal = pct > 0 ? '+' : '';
      return `${sinal}${String(pct).replace('.', ',')}`;
    },
    idColunaDa(celula) {
      return gestaoTaxasHelper.idColunaDaCelula(this.coberturaSelecionada, celula);
    },
    celulasAfetadas() {
      const celulas = [];
      this.faixas.forEach((faixa, faixaIdx) => {
        if (this.escopo === 'linha' && faixaIdx !== this.indiceLinha) return;
        (faixa.taxas || []).forEach(celula => {
          if (this.escopo === 'coluna' && this.idColunaDa(celula) !== this.idColuna) return;
          if (!gestaoTaxasHelper.mudaComAjuste(
            this.coberturaSelecionada, celula.fator, this.percentualNumerico)) return;
          celulas.push({ faixaIdx: faixaIdx, celula: celula });
        });
      });
      return celulas;
    },
    novoFator(celula) {
      return gestaoTaxasHelper.valorAjustado(
        this.coberturaSelecionada, celula.fator, this.percentualNumerico);
    },
    dentroDoLimite(valor) {
      return gestaoTaxasHelper.valorValido(this.coberturaSelecionada, valor);
    },
    preVisualizar() {
      if (!this.podeAjustar) return;
      this.mensagemPreview =
        `Este ajuste de ${this.formatarPercentual(this.percentualNumerico)}% afetará ` +
        `${this.quantidadeAfetada} taxa(s). Clique em "Aplicar Ajuste" para confirmar.`;
    },
    aplicar() {
      if (!this.podeAplicar) return;
      const origem = `Ajuste em massa (${this.formatarPercentual(this.percentualNumerico)}%)`;
      const alteracoes = this.celulasAfetadas().map(item => ({
        faixaIdx: item.faixaIdx,
        idColuna: this.idColunaDa(item.celula),
        valor: this.novoFator(item.celula)
      }));

      this.$emit('aplicar', {
        tabela: this.tabela,
        alteracoes: alteracoes,
        origem: origem
      });
      this.fechar();
    },
    fechar() {
      this.percentual = '';
      this.mensagemPreview = '';
      this.$emit('input', false);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/gestao-taxas/AjusteEmMassaModal.vue